import { observer } from "mobx-react";
import React from "react";
import { Modal } from "@mantine/core";
import PaidNotificationDesign from "./helpers/PaidSuccessfulNotificationDesign";
import { MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS } from "../../../helpers/constants";
import { BOB_MODALS } from "../../helpers/constants";
import { Bob } from "../../stores/Bob";
import { decode } from "@gandlaf21/bolt11-decode";
import { summariseBolt11Invoice } from "../../helpers/payAttemptHelper";

const OurInvoiceWasPaid = observer(({ bob }: { bob: Bob }) => {
  const handleClose = () => {
    bob.setOpenPage(null);
    bob.setOpenModal(null);
    bob.setUserCreatedInvoicePayRequest(null);
  };

  const decoded = decode(bob.userCreatedInvoicePayRequest);
  const summary = summariseBolt11Invoice(decoded);
  const fiat = bob.formatFiat(summary.amountInSatoshis);

  return (
    <Modal
      opened={bob.openModal === BOB_MODALS.OUR_INVOICE_WAS_PAID}
      onClose={handleClose}
      size={MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS}
      radius="md"
      withCloseButton={false}
      overlayProps={{ blur: 0.8 }}
    >
      <PaidNotificationDesign
        title="Payment received!"
        satoshis={summary.amountInSatoshis}
        fiat={fiat}
        onClick={handleClose}
      />
    </Modal>
  );
});

export default OurInvoiceWasPaid;
